import styled from '@emotion/styled';

import type { IconName } from '@hotjar/hotsauce';
import { Icon, Link, tokens } from '@hotjar/hotsauce';

interface ZapierTemplateProps {
  icon: IconName;
  url: string;
  copy: string;
  isLastTemplate?: boolean;
  withoutTree?: boolean;
  onClick?: () => void;
}

export const prefilledTemplates = [
  {
    icon: 'excel',
    surveyUrl: 'https://zapier.com/app/editor/template/1091181',
    feedbackUrl: 'https://zapier.com/app/editor/template/1094434',
    copy: 'common:survey.creation.forwarding.zapier.excel-template',
    name: 'Excel',
  },
  {
    icon: 'trello',
    surveyUrl: 'https://zapier.com/app/editor/template/1091890',
    feedbackUrl: 'https://zapier.com/app/editor/template/1094449',
    copy: 'common:survey.creation.forwarding.zapier.trello-template',
    name: 'Trello',
  },
  {
    icon: 'miro',
    surveyUrl: 'https://zapier.com/app/editor/template/1091179',
    feedbackUrl: 'https://zapier.com/app/editor/template/1094454',
    copy: 'common:survey.creation.forwarding.zapier.miro-template',
    name: 'Miro',
  },
  {
    icon: 'zapier_small',
    surveyUrl: 'https://zapier.com/app/editor',
    feedbackUrl: 'https://zapier.com/app/editor',
    copy: 'common:survey.creation.forwarding.zapier.default-template',
    name: 'Zapier',
  },
];

const TemplateBox = styled.div<{ isLastTemplate: boolean; withoutTree: boolean }>`
  position: relative;
  margin-left: ${tokens.spacer.x1};
  padding: ${tokens.spacer.x1pt5} ${({ withoutTree }) => (withoutTree ? 0 : tokens.spacer.x1pt5)};

  // tree section on the left side of the element

  ${({ isLastTemplate, withoutTree }) =>
    isLastTemplate && !withoutTree
      ? `
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          height: 22px;
          width: 13px;
          border-left: 1px solid ${tokens.color.ui_border};
          border-bottom: 1px solid ${tokens.color.ui_border};
          border-bottom-left-radius: ${tokens.radius.m};
        }`
      : null};

  ${({ isLastTemplate, withoutTree }) =>
    !isLastTemplate && !withoutTree
      ? `
        border-left: 1px solid ${tokens.color.ui_border};

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          height: 1px;
          width: ${tokens.spacer.x1pt5};
          background-color: ${tokens.color.ui_border};
        }`
      : null};
`;

const TemplateIcon = styled(Icon)`
  margin-left: ${tokens.spacer.x1};
  margin-right: ${tokens.spacer.x1};
`;

const TemplateLink = styled(Link)`
  text-decoration: none;
`;

export const ZapierTemplate = ({
  icon,
  url,
  copy,
  isLastTemplate = false,
  withoutTree = false,
  onClick = () => null,
}: ZapierTemplateProps): JSX.Element => {
  return (
    <TemplateBox isLastTemplate={isLastTemplate} withoutTree={withoutTree} onClick={onClick}>
      <TemplateIcon icon={icon} />
      <TemplateLink href={url} kind="inline" isExternal>
        {copy}
      </TemplateLink>
    </TemplateBox>
  );
};
